// Muted-state speaker icon. Ported verbatim from helix-web's
// components/global/icons/CustomIcons/videoCarousel/SoundOff.js — plain white
// fill, no helix-specific tokens involved.
const SoundOff = ({ className }) => (
  <svg
    className={`${className} cursor-pointer`}
    width="35"
    height="32"
    viewBox="0 0 35 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 2.50501C20 0.277759 17.3072 -0.837672 15.7322 0.737245L8.23223 8.23725H5.01509C3.11287 8.23725 1.15176 9.34465 0.582173 11.4123C0.20245 12.7908 0 14.2414 0 15.7372C0 17.2331 0.20245 18.6837 0.582173 20.0622C1.15176 22.1299 3.11287 23.2372 5.01509 23.2372H8.23223L15.7322 30.7373C17.3072 32.3122 20 31.1967 20 28.9695V2.50501Z"
      fill="white"
    />
    <path
      d="M27.1339 11.1033C26.6457 10.6152 25.8543 10.6152 25.3661 11.1033C24.878 11.5915 24.878 12.383 25.3661 12.8711L28.2322 15.7372L25.3661 18.6033C24.878 19.0915 24.878 19.883 25.3661 20.3711C25.8543 20.8593 26.6457 20.8593 27.1339 20.3711L30 17.505L32.8661 20.3711C33.3543 20.8593 34.1457 20.8593 34.6339 20.3711C35.122 19.883 35.122 19.0915 34.6339 18.6033L31.7678 15.7372L34.6339 12.8711C35.122 12.383 35.122 11.5915 34.6339 11.1033C34.1457 10.6152 33.3543 10.6152 32.8661 11.1033L30 13.9695L27.1339 11.1033Z"
      fill="white"
    />
  </svg>
);
export default SoundOff;
